import { forwardRef } from 'react';
import { DataTable } from 'primereact/datatable';

const DataTableWrapper = forwardRef(({
    value,
    filters,
    onFilter,
    onValueChange,
    children,
    customDataTableOptions = {},
}, ref) => {

    if (!value || !filters || !onFilter) {
        throw new Error('Missing props in DataTableWrapper');
    }

    return (
        <DataTable
            value={value}
            filters={filters}
            onFilter={onFilter}
            onValueChange={onValueChange}
            stripedRows
            filterDisplay="menu"
            paginator
            rows={10}
            resizableColumns={true}
            columnResizeMode="expand"
            sortMode="single"
            emptyMessage="No results found."
            ref={ref}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            rowsPerPageOptions={[10, 25, 50]} 
            currentPageReportTemplate="{first} - {last} of {totalRecords} items"
            {...customDataTableOptions}
        >
            {children}
        </DataTable>
    );
});

export default DataTableWrapper;
